export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    const mobileMenu = document.querySelector('#gh-head-mobile-menu');
    if (!burgerButton || !mobileMenu) {
        return;
    }

    const setMenuOpen = (isOpen) => {
        document.body.classList.toggle('gh-head-open', isOpen);
        burgerButton.setAttribute('aria-expanded', String(isOpen));
        burgerButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    };

    burgerButton.addEventListener('click', () => {
        const isOpen = document.body.classList.contains('gh-head-open');
        setMenuOpen(!isOpen);
    });

    document.querySelectorAll('[data-close-mobile-menu]').forEach((link) => {
        link.addEventListener('click', () => {
            setMenuOpen(false);
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && document.body.classList.contains('gh-head-open')) {
            setMenuOpen(false);
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth > 960) {
            setMenuOpen(false);
        }
    });

    setMenuOpen(false);
}
